/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StudentSummaryResponse
 */
export interface StudentSummaryResponse {
    /**
     * 
     * @type {string}
     * @memberof StudentSummaryResponse
     */
    summary: string;
}

/**
 * Check if a given object implements the StudentSummaryResponse interface.
 */
export function instanceOfStudentSummaryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "summary" in value;

    return isInstance;
}

export function StudentSummaryResponseFromJSON(json: any): StudentSummaryResponse {
    return StudentSummaryResponseFromJSONTyped(json, false);
}

export function StudentSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StudentSummaryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'summary': json['summary'],
    };
}

export function StudentSummaryResponseToJSON(value?: StudentSummaryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'summary': value.summary,
    };
}

